module.exports = __webpack_public_path__ + "img/B258.2cebee4f.png";